module.exports = __webpack_public_path__ + "static/media/immaf-world-championships-banner.098fc5f1.jpg";